// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".responsive-image__container.loading{opacity:.5;filter:blur(5px);transition:opacity .3s,filter .3s}.responsive-image__container{opacity:1;filter:none}", ""]);
// Exports
module.exports = exports;
